export default __webpack_public_path__ + "static/media/banner3.6ea83c14.png";